import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Mapped, Union } from "@/__main__/data-model.mjs";

const recurringIntervalModel = Union(["month"]);

export type PaymentPlanInterval = FromModel<typeof recurringIntervalModel>;

export const paymentPlanModel = {
  name: String,
  price: Number,
  currency: String,
  recurringInterval: recurringIntervalModel,
  // Missing from model currently
  // planType: String, // SUBSCRIBER_MONTHLY
} satisfies ModelDefinition;

export interface PaymentPlan extends FromModel<typeof paymentPlanModel> {}

export const PaymentPlansModel = createModel({
  data: { paymentPlans: [paymentPlanModel] },
}).transform(
  Mapped({
    key: String,
    value: paymentPlanModel,
  }),
  (data) => {
    return data.data.paymentPlans.reduce((acc, p) => {
      acc[p.name] = p;
      return acc;
    }, {});
  },
);
